import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import { PopoverAnchor, Popover, PopoverContent, SelectInput } from "..";

export default function SingleSort({ value, onChange, onDelete, fields = [] }) {
  const [openPopOver, setOpenPopOver] = useState(false);

  const selectedField = fields.find((f) => f.id === value.field);
  const directionOptions = [
    { label: "Ascending", value: "asc" },
    { label: "Descending", value: "desc" },
  ];

  return (
    <>
      <div className="cursor-default hover:bg-gray-50 p-2">
        <Popover>
          <PopoverAnchor
            placement="bottom"
            open={openPopOver}
            onOpenChange={setOpenPopOver}
          >
            <div className="grigora-singlesort__anchor flex items-center justify-between gap-2">
              <p>
                {`${selectedField?.label || "Select Field"} ${
                  value.direction === "asc" ? "Ascending" : "Descending"
                }`}
              </p>
              <div className="flex items-center gap-1">
                <FontAwesomeIcon icon={faPen} className="p-2 cursor-pointer" />
                <FontAwesomeIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete();
                  }}
                  icon={faTrash}
                  className="p-2 cursor-pointer"
                />
              </div>
            </div>
          </PopoverAnchor>
          <PopoverContent className="outline-none !z-[1000] !rounded-[6px] !bg-editor-light-main !shadow-editor-floating-elements">
            <div className="popover__content w-[250px] p-4 border">
              <SelectInput
                isResetVisible={false}
                value={value.field}
                onChange={(val) => {
                  onChange({
                    ...value,
                    field: val,
                  });
                }}
                options={fields.map((field) => ({
                  label: field.label,
                  value: field.id,
                }))}
                label="Field"
              />

              <SelectInput
                isResetVisible={false}
                value={value.direction}
                onChange={(val) => {
                  onChange({ ...value, direction: val });
                }}
                options={directionOptions}
                label="Direction"
              />
            </div>
          </PopoverContent>
        </Popover>
      </div>
    </>
  );
}
